import { twMerge } from "tailwind-merge";

export interface CircularProgressProps {
  className?: string;
  style?: React.CSSProperties;
}

export default function CircularProgress({
  className,
  style,
}: CircularProgressProps) {
  return (
    <>
      <svg
        aria-hidden="true"
        className={twMerge("animate-spin h-5 w-5 text-white", className)}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={style}
      >
        <circle
          className="opacity-50"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-95"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
      <span className="sr-only">Loading...</span>
    </>
  );
}
